<div class="relative flex flex-row h-full w-full" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="absolute inset-0 z-10 overflow-hidden green-noise-bg flex items-center justify-center">

        <button type="button" (click)="closeVideoFeedback()" aria-label="Close"
            class="absolute top-3 left-3 z-20 flex items-center justify-center size-9 bg-white/10 hover:bg-white/20 active:bg-white/15 backdrop-blur-md rounded-full border border-white/20 text-white/90 transition-all duration-150 shadow-sm focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white/50">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                stroke="currentColor" class="size-4">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>
        </button>


        <div class="relative h-full w-full blackout-card-container flex flex-col overflow-hidden p-2 gap-y-2">
            <div class="grid grid-cols-3 gap-x-2 h-full w-full">

                <!-- ── Left: Video player ─────────────────────────────────── -->
                <article class="tto-video-media-pane col-span-2 min-h-0 flex flex-col overflow-hidden">
                    <div class="flex min-h-0 h-full w-full flex-col items-center justify-center">
                        <!-- The Video Section: height-bounded so full 9:16 frame stays on screen (object-contain inside) -->
                        <div class="aspect-h-16 aspect-w-9 relative bg-muted overflow-hidden rounded-lg">
                            @if (playbackUrl(); as src) {
                            <video #analysisVideo class="portrait w-full h-full object-contain"
                                [class.opacity-0]="!playbackStarted()" [class.opacity-100]="playbackStarted()"
                                (click)="onVideoClick(analysisVideo)" (timeupdate)="onTimeUpdate(analysisVideo)"
                                [src]="src">
                            </video>
                            <div class="absolute inset-0 flex items-center justify-center bg-muted transition-opacity duration-500 ease-out"
                                [class.opacity-100]="!playbackStarted()" [class.opacity-0]="playbackStarted()"
                                [class.pointer-events-none]="playbackStarted()">
                                <img [src]="video().video_info.thumbnail_url" alt="Video thumbnail preview"
                                    class="portrait absolute inset-0 h-full w-full object-contain" />
                                @if (showPlayButton()) {
                                <button type="button"
                                    class="relative z-10 flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-white/90 text-zinc-900 shadow-lg backdrop-blur-sm transition-transform hover:scale-105 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                                    (click)="onPlayClick(analysisVideo)" aria-label="Play video">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                        class="ml-0.5 h-9 w-9" aria-hidden="true">
                                        <path d="M8 5v14l11-7L8 5z" />
                                    </svg>
                                </button>
                                }
                            </div>
                            } @else {
                            <!-- <atom-video-thumbnail [videoUrl]="playbackUrl()"
                                [thumbnailURL]="video().video_info.thumbnail_url"></atom-video-thumbnail> -->
                            <img [src]="video().video_info.thumbnail_url" alt="Video thumbnail preview"
                                class="portrait w-full h-full object-contain" />
                            }
                        </div>
                        <!-- The Video Section - END -->

                        <!-- Graph & Slider Section -->
                        @if (video() && video().video_view_retention && video().video_view_retention.length > 0) {
                        <div class="shrink-0 flex flex-col w-full max-w-4xl mx-auto gap-y-2">

                            <!-- Retention Graph -->
                            <div echarts class="w-full h-24 mt-2" style="margin: 0 8px;"
                                [options]="retentionChartOption()" [merge]="retentionChartMerge()" [autoResize]="true">
                            </div>
                            <!-- Retention Graph END -->

                            <mat-slider min="0" [max]="video().video_view_retention.length - 1" step="1" [discrete]="true"
                                [showTickMarks]="true">
                                <input matSliderThumb [value]="currentTime()" (valueChange)="onSliderChange($event)">
                            </mat-slider>

                            <div class="w-full flex flex-row items-center justify-between" style="margin: 0 8px;">
                                <div class="flex flex-row items-center gap-x-1">
                                    <span class="text-sm font-medium text-white">{{ formatTime(currentTime()) }}</span>
                                    @if (retentionAtCurrentTime() !== null) {
                                    <span class="text-sm text-white/60">({{ retentionAtCurrentTime() | number:'1.0-0'
                                        }}%)</span>
                                    }
                                </div>
                                <div class="flex flex-col items-center justify-center">
                                    <span class="text-sm font-medium text-white">{{ getVideoLengthTime() }}</span>
                                </div>
                            </div>


                        </div>
                        }
                        <!-- Graph & Slider Section - END -->
                    </div>
                </article>

                <!-- ── Right: Info panel ──────────────────────────────────── -->
                <article
                    class="col-span-1 rounded-2xl border border-border h-full bg-card overflow-hidden flex flex-col shadow-xl shadow-black/20">

                    <!-- ── Panel header ──────────────────────────────────── -->
                    <header class="sticky top-0 z-10 drawer-header-primary shrink-0 flex flex-col px-2 pt-4 gap-y-2">

                        <div class="flex space-x-3 h-full items-start w-full">
                            <div class="min-w-0 flex-1 px-2">
                                <p class="text-md font-semibold text-primary">
                                    Video Analysis & Boosting
                                </p>
                                <p class="text-sm text-secondary">
                                    Analyze the video and get insights.
                                </p>
                            </div>

                            <div class="h-full flex flex-col justify-between items-end">
                            </div>
                        </div>
                        <!-- Quick Stats -->
                        <div class="mt-2 w-full flex flex-row justify-between items center">
                            <div class="flex flex-col items-center justify-center px-6 space-y-1">
                                <span class="text-muted-foreground"><svg xmlns="http://www.w3.org/2000/svg" width="24"
                                        height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                        <path
                                            d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z" />
                                    </svg></span>
                                <span class="text-sm font-semibold tabular-nums text-foreground">{{
                                    formatService.convertIntToString(video().video_views) }}</span>
                            </div>

                            <div class="flex flex-col items-center justify-center px-6 space-y-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-5 text-muted-foreground">
                                    <path
                                        d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5" />
                                </svg>
                                <span class="text-sm font-semibold tabular-nums text-foreground">{{
                                    formatService.convertIntToString(video().likes) }}</span>
                            </div>

                            <div class="flex flex-col items-center justify-center px-6 space-y-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-5 text-muted-foreground">
                                    <path
                                        d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719" />
                                </svg>
                                <span class="text-sm font-semibold tabular-nums text-foreground">{{
                                    formatService.convertIntToString(video().comments) }}</span>
                            </div>

                            <div class="flex flex-col items-center justify-center px-6 space-y-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-5 text-muted-foreground">
                                    <path d="M12 3v12" />
                                    <path d="m17 8-5-5-5 5" />
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                </svg>
                                <span class="text-sm font-semibold tabular-nums text-foreground">{{
                                    formatService.convertIntToString(video().shares) }}</span>
                            </div>
                        </div>
                        <!-- Quick Stats - END -->

                        <!-- Tabs nav -->
                        <nav aria-label="Tabs" class="flex flex-row w-full justify-center space-x-6 cursor-pointer">
                            <a (click)="setSelectedTab('overview')" aria-current="page"
                                class="group inline-flex items-center border-b-2 px-1 py-2.5 text-sm font-medium transition-all duration-200 ease-in-out overflow-hidden"
                                [class]="getSelectedTabClass('overview')">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="size-4 shrink-0 transition-all duration-200 ease-in-out group-hover:mr-1.5"
                                    [class]="getSelectedTabIconClass('overview') + (selectedTab() === 'overview' ? ' mr-1.5' : '')">
                                    <rect width="7" height="9" x="3" y="3" rx="1" />
                                    <rect width="7" height="5" x="14" y="3" rx="1" />
                                    <rect width="7" height="9" x="14" y="12" rx="1" />
                                    <rect width="7" height="5" x="3" y="16" rx="1" />
                                </svg>
                                <span class="transition-all duration-200 ease-in-out whitespace-nowrap"
                                    [class]="selectedTab() === 'overview' ? 'opacity-100 max-w-xs' : 'opacity-0 max-w-0 group-hover:opacity-100 group-hover:max-w-xs'">
                                    Overview
                                </span>
                            </a>

                            <a (click)="setSelectedTab('viewers')" aria-current="page"
                                class="group inline-flex items-center border-b-2 px-1 py-2.5 text-sm font-medium transition-all duration-200 ease-in-out overflow-hidden"
                                [class]="getSelectedTabClass('viewers')">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="size-4 shrink-0 transition-all duration-200 ease-in-out group-hover:mr-1.5"
                                    [class]="getSelectedTabIconClass('viewers') + (selectedTab() === 'viewers' ? ' mr-1.5' : '')">
                                    <path d="M3 7V5a2 2 0 0 1 2-2h2" />
                                    <path d="M17 3h2a2 2 0 0 1 2 2v2" />
                                    <path d="M21 17v2a2 2 0 0 1-2 2h-2" />
                                    <path d="M7 21H5a2 2 0 0 1-2-2v-2" />
                                    <circle cx="12" cy="12" r="1" />
                                    <path
                                        d="M18.944 12.33a1 1 0 0 0 0-.66 7.5 7.5 0 0 0-13.888 0 1 1 0 0 0 0 .66 7.5 7.5 0 0 0 13.888 0" />
                                </svg>
                                <span class="transition-all duration-200 ease-in-out whitespace-nowrap"
                                    [class]="selectedTab() === 'viewers' ? 'opacity-100 max-w-xs' : 'opacity-0 max-w-0 group-hover:opacity-100 group-hover:max-w-xs'">
                                    Viewers
                                </span>
                            </a>

                            <a (click)="setSelectedTab('engagement')" aria-current="page"
                                class="group inline-flex items-center border-b-2 px-1 py-2.5 text-sm font-medium transition-all duration-200 ease-in-out overflow-hidden"
                                [class]="getSelectedTabClass('engagement')">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="size-4 shrink-0 transition-all duration-200 ease-in-out group-hover:mr-1.5"
                                    [class]="getSelectedTabIconClass('engagement') + (selectedTab() === 'engagement' ? ' mr-1.5' : '')">
                                    <path
                                        d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2" />
                                </svg>
                                <span class="transition-all duration-200 ease-in-out whitespace-nowrap"
                                    [class]="selectedTab() === 'engagement' ? 'opacity-100 max-w-xs' : 'opacity-0 max-w-0 group-hover:opacity-100 group-hover:max-w-xs'">
                                    Engagement
                                </span>
                            </a>

                            <a (click)="setSelectedTab('boosting-v2')" aria-current="page"
                                class="group inline-flex items-center border-b-2 px-1 py-2.5 text-sm font-medium transition-all duration-200 ease-in-out overflow-hidden"
                                [class]="getSelectedTabClass('boosting-v2')">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="size-4 shrink-0 transition-all duration-200 ease-in-out group-hover:mr-1.5"
                                    [class]="getSelectedTabIconClass('boosting-v2') + (selectedTab() === 'boosting-v2' ? ' mr-1.5' : '')">
                                    <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
                                    <path
                                        d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09" />
                                    <path
                                        d="M9 12a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.4 22.4 0 0 1-4 2z" />
                                    <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 .05 5 .05" />
                                </svg>
                                <span class="transition-all duration-200 ease-in-out whitespace-nowrap"
                                    [class]="selectedTab() === 'boosting-v2' ? 'opacity-100 max-w-xs' : 'opacity-0 max-w-0 group-hover:opacity-100 group-hover:max-w-xs'">
                                    Boosting
                                </span>
                            </a>


                        </nav>
                        <!-- Tabs nav - END -->
                    </header>

                    <!-- ── Panel body ────────────────────────────────────── -->
                    <main class="flex-1 flex-col overflow-hidden drawer-body-primary">
                        @switch (selectedTab()) {
                        @case ('overview') {
                        <vat-analysis-overview [video]="video()"></vat-analysis-overview>
                        }
                        @case ('viewers') {
                        <vat-analysis-viewers [video]="video()"></vat-analysis-viewers>
                        }
                        @case ('engagement') {
                        <vat-analysis-engagement></vat-analysis-engagement>
                        }
                        @case ('boosting') {
                        <vat-analysis-boosting [video]="video()"></vat-analysis-boosting>
                        }
                        @case ('boosting-v2') {
                        <vat-analysis-boosting-v2 [video]="video()"></vat-analysis-boosting-v2>
                        }
                        }
                    </main>
                </article>

            </div>
        </div>
    </div>
</div>